module.exports = __webpack_public_path__ + "img/saintbrand-reviews.ee0e4e44.jpg";